import React from 'react';

export const cpcTujuanConfig = [
  {
    path: '/service-cash-movement-vaulting',
    component: React.lazy(() => import('./listing/listing')),
  },
  {
    path: '/service-cash-movement-vaulting/add',
    component: React.lazy(() => import('./add/add')),
  },
  {
    path: '/service-cash-movement-vaulting/accept',
    component: React.lazy(() => import('./accept/accept')),
  },
  {
    path: '/service-cash-movement-vaulting/reject',
    component: React.lazy(() => import('./reject/reject')),
  },
];
